// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.easycommerce-product-list-swiper-slide .swiper-wrapper .swiper-slide {
    border: 1px solid #1203500d;
    border-radius: 8px;
    cursor: pointer;
}
.easycommerce-product-list-swiper-slide
    .swiper-wrapper
    .swiper-slide.swiper-slide-thumb-active {
    border: 1px solid var(--color-ec-primary);
}
.easycommerce-product-list-swiper-slide .swiper-wrapper .swiper-slide img {
    border-radius: 8px;
}
.easycommerce-product-list-swiper-slide .swiper-button-prev,
.easycommerce-product-list-swiper-slide .swiper-button-next {
    width: 32px;
    height: 32px;
    background-color: #fff;
    border-radius: 50%;
    box-shadow: 0px 3px 40.4px 0px #00000026;
}
.easycommerce-product-list-swiper-slide .swiper-button-prev::after,
.easycommerce-product-list-swiper-slide .swiper-button-next::after {
    font-size: 12px;
    color: var(--color-ec-body);
    line-height: 22px;
    font-weight: bolder;
    top: 57%;
}
.easycommerce-product-list-swiper-slide .swiper-button-prev:focus::after,
.easycommerce-product-list-swiper-slide .swiper-button-next:focus::after {
    color: var(--color-ec-primary);
}
`, "",{"version":3,"sources":["webpack://./blocks/single-product/gallery/assets/editor.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;AACnB;AACA;;;IAGI,yCAAyC;AAC7C;AACA;IACI,kBAAkB;AACtB;AACA;;IAEI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;AAC5C;AACA;;IAEI,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;IACjB,mBAAmB;IACnB,QAAQ;AACZ;AACA;;IAEI,8BAA8B;AAClC","sourcesContent":[".easycommerce-product-list-swiper-slide .swiper-wrapper .swiper-slide {\n    border: 1px solid #1203500d;\n    border-radius: 8px;\n    cursor: pointer;\n}\n.easycommerce-product-list-swiper-slide\n    .swiper-wrapper\n    .swiper-slide.swiper-slide-thumb-active {\n    border: 1px solid var(--color-ec-primary);\n}\n.easycommerce-product-list-swiper-slide .swiper-wrapper .swiper-slide img {\n    border-radius: 8px;\n}\n.easycommerce-product-list-swiper-slide .swiper-button-prev,\n.easycommerce-product-list-swiper-slide .swiper-button-next {\n    width: 32px;\n    height: 32px;\n    background-color: #fff;\n    border-radius: 50%;\n    box-shadow: 0px 3px 40.4px 0px #00000026;\n}\n.easycommerce-product-list-swiper-slide .swiper-button-prev::after,\n.easycommerce-product-list-swiper-slide .swiper-button-next::after {\n    font-size: 12px;\n    color: var(--color-ec-body);\n    line-height: 22px;\n    font-weight: bolder;\n    top: 57%;\n}\n.easycommerce-product-list-swiper-slide .swiper-button-prev:focus::after,\n.easycommerce-product-list-swiper-slide .swiper-button-next:focus::after {\n    color: var(--color-ec-primary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
